import { z } from "zod";

/**
 * An OpenAI error envelope. Its own module so a hot path can check for an
 * error without building every OpenAI request and response schema.
 */
export const OpenAIInferenceErrorResponseSchema = z
  .object({ error: z.record(z.string(), z.any()) })
  .passthrough();

export type OpenAIInferenceErrorResponse = z.infer<
  typeof OpenAIInferenceErrorResponseSchema
>;
